


































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class ApplicationCardComponent extends Vue {
  @Prop() card: any;
  @Prop() index: any;
  @Prop() showStatus: boolean;

  mounted() {}
  showDeclaration(InitiativeCallId, ProgramId, TypeId) {
    this.$emit("showDeclaration", InitiativeCallId, ProgramId, TypeId);
  }
  /**date conversion**/
  dateFormat(date) {
    return this.$services.format.formatDate(date);
  }
  computedHref(Url){
    var prefix = 'http://'
    var securePrefix='https://'
    var emptyUrl='#'
    if(Url != null && Url.substr(0, securePrefix.length) !== securePrefix){
      if(Url.substr(0, prefix.length) == prefix){
         return Url
      }
      else{
     let cahngedUrl = securePrefix + Url;
      return cahngedUrl
      }
    }
    else if(Url == null){
      return emptyUrl
    }
    else{
     return Url
    }
  }
  downloadIns(e) {
    let file = {};
    file["uploadedFileName"] = e.InstructionFile;
    file["documentId"] = e.documentId;
    this.$services.document.download(file);
  }
  downloadFaq(e) {
    let file = {};
    file["uploadedFileName"] = e.FaqFile;
    file["documentId"] = e.documentId;
    this.$services.document.download(file);
  }
}
